cpntMap.set('awe-multi-offers', {
  props:{
    avails: { type:Array, default: function(){return []} },
    defaultOpen: { type:Boolean, default: false },
    showOfflineBuyBtn: {type: Boolean, default: true},
    showPrices: {type: Boolean, default: true},
  },
  data: function(){
    return {
      i18n: window.i18n,
      expanded: this.defaultOpen,
      app,
    }
  },
  mounted: function(){
    // auto-expand if only one offer
    if (this.avails.length === 1) {
      this.expanded = true
    }
  },
  methods:{
  },
  template:`
  <div class="multi-offers" :class="{expanded}">
    <button class="offer-toggle" @click="expanded = !expanded" v-show="!expanded">
      <span class="lbl">{{ i18n.getString('MULTIOFFER_TOGGLE_LBL', {count: avails.length}) }}</span>
      <svg class="arrow" viewBox="0 0 25 15" xmlns="http://www.w3.org/2000/svg">
        <use href="#toggle"/>
      </svg>
    </button>

    <div class="offers" v-show="expanded">
      <template class="nested-avail" v-for="avail in avails">
        <span class="cell price" v-if="showPrices">
          {{i18n.formatPrice(avail.price.amount, avail.price.currency)}}
        </span>
        <span class="cell pkg">{{avail.product.pkg || avail.product.containing}}</span>
        <span class="cell btn-ctnr">
          <a v-if="showOfflineBuyBtn" 
            @click="app.redirect($event, avail)"
            :href="avail.clkUrl" class="btn"
            :aria-label="i18n.getString('BUY_LBL', {name:avail.store.name})"
            target="_blank"
          >
            {{i18n.getString('BUY')}}
          </a>
        </span>
      </template>
    </div>
  </div>
  `
})